import TreeView16 from '@carbon/icons-react/es/tree-view/16';
import { Tooltip } from 'antd';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { Task } from 'data/tasks';
import { useTranslation } from 'hooks/use-translation';

const SubtaskIcon = styled(TreeView16)`
  margin-right: var(--spacing-03);
  color: var(--gray-70);
`;

const IconText = styled.span`
  align-items: center;
  display: flex;
`;

export const TaskFooterAdditionalDetails: FC<{ task: Task; subTasks: Task[] }> =
  ({ subTasks }) => {
    const shosSubTasksText = useTranslation('show_subtasks');

    const completedSubtasks = useMemo(
      () => subTasks.filter((subtask) => subtask.completedAt),
      [subTasks],
    );

    if (subTasks?.length) {
      return (
        <Tooltip title={shosSubTasksText}>
          <IconText>
            <SubtaskIcon />
            {completedSubtasks.length}/{subTasks.length}
          </IconText>
        </Tooltip>
      );
    }

    return null;
  };
